/* eslint-disable @typescript-eslint/no-explicit-any */
import EditIcon from '@mui/icons-material/Edit';
import {
  GridColDef,
  GridRenderCellParams,
  GridRowParams,
  GridValueFormatterParams
} from '@mui/x-data-grid-premium';
import { baseCell, currencyCell } from 'components/cells';
import productStatusCell from 'components/cells/product-status-cell';
import {
  filterOperators,
  numberFilterOperators,
  singleSelectFilterOperators
} from 'components/enhanced';
import DataGridCell from 'components/enhanced/data-grid/components/cell/DataGridCell';
import { currencyFormatter } from 'components/helpers/currency-formatter';
import { useTranslation } from 'react-i18next';
import { StatusOption } from 'shared/types/general';

export function ContractLinesColumns(
  refresh: any,
  statusOptions: StatusOption[] = [],
  handleEdit?: (row: any) => void,
  disableEdit?: boolean
): GridColDef[] {
  const { t } = useTranslation();

  const columns: GridColDef[] | any[] = [
    {
      field: 'product',
      headerName: t(`global.product`),
      width: 150,
      valueGetter: (params) => params.row.product.code
    },
    {
      field: 'product_description',
      headerName: t(`global.product_description`),
      width: 250,
      valueGetter: (params) => params.row.product.description
    },
    {
      field: 'order_notes',
      headerName: t(`entities.product.order_notes`),
      width: 220,
      filterOperators,
      valueGetter: (params) => params.row.order_notes ?? '',
      renderCell: baseCell
    },
    {
      field: 'status',
      headerName: t(`global.status`),
      width: 120,
      type: 'singleSelect',
      editable: false,
      valueOptions: statusOptions.map((opt) => ({
        value: String(opt.value),
        label: t(`${opt.display_name}`)
      })),
      valueGetter: (params) => params.row.status,
      filterOperators: singleSelectFilterOperators,
      renderCell: productStatusCell(t)
    },
    {
      field: 'unit_price',
      headerName: t(`entities.contract_line.unit_price`),
      width: 120,
      align: 'center',
      //editable: true,
      filterOperators: numberFilterOperators,
      valueFormatter: (params: GridValueFormatterParams) => {
        return currencyFormatter(params.value, { significantDigits: 3 });
      },
      renderCell: (params: GridRenderCellParams) => currencyCell(params, 3)
    },
    // {
    //   field: 'iva',
    //   headerName: t(`entities.contract_line.iva`),
    //   width: 100,
    //   filterable: false,
    //   align: 'center',
    //   filterOperators: numberFilterOperators,
    //   valueGetter: (params) => params.row.iva,
    //   renderCell: baseCell
    // },
    {
      field: 'initial_available_units',
      headerName: t(`entities.contract_line.initial_available_units`),
      width: 120,
      align: 'center',
      filterOperators: numberFilterOperators,
      //editable: true,
      renderCell: baseCell
    },
    {
      field: 'available_units',
      headerName: t(`entities.contract_line.available_units`),
      filterOperators: numberFilterOperators,
      align: 'center',
      width: 120,
      renderCell: baseCell
    },
    {
      field: 'initial_discounted_units',
      headerName: t(`entities.contract_line.initial_discounted_units`),
      align: 'center',
      filterOperators: numberFilterOperators,
      width: 150,
      //editable: true,
      renderCell: baseCell
    },
    {
      field: 'available_discounted_units',
      headerName: t(`entities.contract_line.available_discounted_units`),
      align: 'center',
      filterOperators: numberFilterOperators,
      width: 150,
      renderCell: baseCell
    },
    {
      field: 'warehouse',
      headerName: t(`global.warehouse`),
      width: 200,
      filterOperators,
      valueGetter: (params) => params.value?.code ?? params.value,
      renderCell: (params: GridRenderCellParams) => {
        return <DataGridCell content={params.value} />;
      }
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: t(`global.actions`),
      width: 100,
      getActions: (params: GridRowParams) => {
        return [
          {
            label: t('actions.edit'),
            icon: <EditIcon fontSize="small" />,
            onClick: () => handleEdit(params.row),
            visible: !disableEdit
          }
        ];
      }
    } as GridColDef
  ];

  return columns;
}
